var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCircle = function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.93,
    y1: 155.31,
    x2: 231.43,
    y2: 24.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,187.5c-48.25,0-87.5-39.25-87.5-87.5S51.75,12.5,100,12.5s87.5,39.25,87.5,87.5-39.25,87.5-87.5,87.5ZM155.47,100c0,3.45-2.8,6.25-6.25,6.25h-42.97v42.97c0,3.45-2.8,6.25-6.25,6.25s-6.25-2.8-6.25-6.25v-42.97h-42.97c-3.45,0-6.25-2.8-6.25-6.25s2.8-6.25,6.25-6.25h42.97v-42.97c0-3.45,2.8-6.25,6.25-6.25s6.25,2.8,6.25,6.25v42.97h42.97c3.45,0,6.25,2.8,6.25,6.25Z"
  })));
};
export default SvgAddCircle;